/* eslint-disable radix */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-comment-textnodes */

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import {
  Button,
  Input,
  Loader,
  IconButton,
  Whisper,
  Popover,
  Dropdown,
} from 'rsuite';
import {
  MdArrowBack,
  MdSave,
  MdVisibility,
  MdAdd,
  MdDelete,
  MdDragIndicator,
  MdCode,
  MdHelp,
  MdSettings,
  MdSwapVert,
} from 'react-icons/md';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import {
  PageContainer,
  MainContent,
  PageHeader,
  Section,
  FormGroup,
  BlockEditor,
  AddBlockButton,
  EmptyState,
  QuestionCard,
} from './styles';
import StatusBadge from './components/StatusBadge';
import RichTextEditor from './components/RichTextEditor';
import QuestionSelector from './components/QuestionSelector';
import QuestionEditor from './components/QuestionEditor';
import ConfirmDialog from './components/ConfirmDialog';
import SortableList from './components/SortableList';
import {
  getModuloById,
  updateModulo,
  getConteudos,
  createConteudo,
  updateConteudo,
  deleteConteudo,
  reorderConteudos,
  createQuestao,
} from '../../services/treinamentos';

function EditorModuloAula({showEditorModulos, setShowEditorModulos, idTreinamentoModulos,idModulo, setShowModulos}) {
  // const { id: treinamentoId, moduloId } = useParams();
  const treinamentoId = idTreinamentoModulos;
  const moduloId = idModulo;
  const history = useHistory();

  // Estado geral
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [_modulo, setModulo] = useState(null);
  const [treinamento, setTreinamento] = useState(null);

  // Título do módulo
  const [tituloModulo, setTituloModulo] = useState('');
  const [hasChanges, setHasChanges] = useState(false);

  // Blocos de conteúdo
  const [blocos, setBlocos] = useState([]);
  const [loadingBlocos, setLoadingBlocos] = useState(false);

  // Modais
  const [showAddBlock, setShowAddBlock] = useState(false);
  const [questionSelectorOpen, setQuestionSelectorOpen] = useState(false);
  const [questionEditorOpen, setQuestionEditorOpen] = useState(false);
  const [deleteBlockModal, setDeleteBlockModal] = useState({ open: false, id: null });
  const [deletingBlock, setDeletingBlock] = useState(false);
  const [savingQuestion, setSavingQuestion] = useState(false);

  // Carregar módulo
  const loadModulo = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getModuloById(moduloId);
      setModulo(data);
      setTituloModulo(data.titulo || '');
      setTreinamento(data.treinamento);
    } catch (error) {
      toast.error('Erro ao carregar módulo');
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [moduloId]);

  // Carregar blocos
  const loadBlocos = useCallback(async () => {
    setLoadingBlocos(true);
    try {
      const data = await getConteudos(moduloId);
      setBlocos(data || []);
    } catch (error) {
      console.error('Erro ao carregar blocos:', error);
    } finally {
      setLoadingBlocos(false);
    }
  }, [moduloId]);

  useEffect(() => {
    loadModulo();
    loadBlocos();
  }, [loadModulo, loadBlocos]);

  // Salvar título do módulo
  const handleSaveTitulo = useCallback(async () => {
    if (!tituloModulo.trim()) {
      toast.error('O título é obrigatório');
      return;
    }

    setSaving(true);
    try {
      await updateModulo(moduloId, { titulo: tituloModulo });
      toast.success('Módulo salvo com sucesso!');
      setHasChanges(false);
    } catch {
      toast.error('Erro ao salvar módulo');
    } finally {
      setSaving(false);
    }
  }, [moduloId, tituloModulo]);

  // Adicionar bloco HTML
  const handleAddHtmlBlock = useCallback(async () => {
    setShowAddBlock(false);
    try {
      await createConteudo({
        id_modulo: parseInt(moduloId),
        tipo_bloco: 'html',
        conteudo_texto: '<p>Digite seu conteúdo aqui...</p>',
        ordem: blocos.length + 1,
      });
      loadBlocos();
      toast.success('Bloco de texto adicionado');
    } catch {
      toast.error('Erro ao adicionar bloco');
    }
  }, [moduloId, blocos.length, loadBlocos]);

  // Adicionar bloco de pergunta
  const handleAddQuestionBlock = useCallback(() => {
    setShowAddBlock(false);
    setQuestionSelectorOpen(true);
  }, []);

  // Selecionar questão do banco
  const handleSelectQuestion = useCallback(async (questao) => {
    try {
      await createConteudo({
        id_modulo: parseInt(moduloId),
        tipo_bloco: 'pergunta_pratica',
        id_questao: questao.id,
        ordem: blocos.length + 1,
      });
      loadBlocos();
      toast.success('Pergunta adicionada');
    } catch {
      toast.error('Erro ao adicionar pergunta');
    }
  }, [moduloId, blocos.length, loadBlocos]);

  // Criar nova questão
  const handleCreateQuestion = useCallback(async (data) => {
    setSavingQuestion(true);
    try {
      const questao = await createQuestao(data);
      
      // Adicionar como bloco
      await createConteudo({
        id_modulo: parseInt(moduloId),
        tipo_bloco: 'pergunta_pratica',
        id_questao: questao.id,
        ordem: blocos.length + 1,
      });
      
      setQuestionEditorOpen(false);
      setQuestionSelectorOpen(false);
      loadBlocos();
      toast.success('Questão criada e adicionada!');
    } catch {
      toast.error('Erro ao criar questão');
    } finally {
      setSavingQuestion(false);
    }
  }, [moduloId, blocos.length, loadBlocos]);

  // Atualizar bloco HTML
  const handleUpdateHtmlBlock = useCallback(async (blocoId, conteudo) => {
    try {
      await updateConteudo(blocoId, { conteudo_texto: conteudo });
    } catch (error) {
      console.error('Erro ao atualizar bloco:', error);
    }
  }, []);

  // Excluir bloco
  const handleDeleteBlock = useCallback(async () => {
    if (!deleteBlockModal.id) return;

    setDeletingBlock(true);
    try {
      await deleteConteudo(deleteBlockModal.id);
      toast.success('Bloco excluído');
      setDeleteBlockModal({ open: false, id: null });
      loadBlocos();
    } catch {
      toast.error('Erro ao excluir bloco');
    } finally {
      setDeletingBlock(false);
    }
  }, [deleteBlockModal.id, loadBlocos]);

  // Reordenar blocos
  const handleReorderBlocos = useCallback(async (newBlocos) => {
    setBlocos(newBlocos);
    try {
      const blocosOrdem = newBlocos.map((b, index) => ({
        id: b.id,
        ordem: index + 1,
      }));
      await reorderConteudos(moduloId, blocosOrdem);
    } catch {
      toast.error('Erro ao reordenar blocos');
      loadBlocos();
    }
  }, [moduloId, loadBlocos]);

  if (loading) {
    return (
      <PageContainer>
        <MainContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Loader size="lg" content="Carregando..." />
        </MainContent>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <MainContent>
        <PageHeader>
          <div
            className="back-button"
            onClick={() => setShowEditorModulos(false)}
          >
            <MdArrowBack />
            Voltar
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              appearance="primary"
              onClick={handleSaveTitulo}
              loading={saving}
              disabled={!hasChanges}
            >
              <MdSave style={{ marginRight: 8 }} />
              Salvar
            </Button>
          </div>
        </PageHeader>


        <Section>
          <FormGroup>
            <label>Título do Módulo</label>
            <Input
              value={tituloModulo}
              onChange={(v) => {
                setTituloModulo(v);
                setHasChanges(true);
              }}
              placeholder="Título do módulo"
              size="lg"
            />
          </FormGroup>
        </Section>
        <Section>
          <h2>Blocos de Conteúdo</h2>

          {loadingBlocos ? (
            <div style={{ textAlign: 'center', padding: 40 }}>
              <Loader content="Carregando blocos..." />
            </div>
          ) : blocos.length === 0 ? (
            <EmptyState>
              <MdCode style={{ fontSize: 48 }} />
              <h3>Nenhum conteúdo</h3>
              <p>Adicione blocos de texto ou perguntas práticas</p>
            </EmptyState>
          ) : (
            <SortableList
              items={blocos}
              onReorder={handleReorderBlocos}
              keyExtractor={(item) => item.id}
              renderItem={(bloco, index, isDragging) => (
                <BlockEditor style={{ opacity: isDragging ? 0.5 : 1 }}>
                  <div className="block-header">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <MdDragIndicator style={{ cursor: 'grab', color: '#999' }} />
                      <span className="block-type">
                        {bloco.tipo_bloco === 'html' ? 'HTML' : 'Pergunta Prática'}
                      </span>
                    </div>
                    <IconButton
                      icon={<MdDelete />}
                      appearance="subtle"
                      color="red"
                      size="sm"
                      onClick={() => setDeleteBlockModal({ open: true, id: bloco.id })}
                    />
                  </div>

                  {bloco.tipo_bloco === 'html' ? (
                    <RichTextEditor
                      value={bloco.conteudo_texto || ''}
                      onChange={(content) => handleUpdateHtmlBlock(bloco.id, content)}
                    />
                  ) : (
                    <QuestionCard>
                      <div className="question-header">
                        ❓ {bloco.questao?.enunciado || 'Questão não encontrada'}
                      </div>
                      {bloco.questao?.alternativas && (
                        <div className="alternatives">
                          {bloco.questao.alternativas.map((alt) => (
                            <div
                              key={alt.id}
                              className={`alternative ${alt.correta ? 'correct' : ''}`}
                            >
                              {alt.correta ? '✓' : '○'} {alt.texto}
                            </div>
                          ))}
                        </div>
                      )}
                    </QuestionCard>
                  )}
                </BlockEditor>
              )}
            />
          )}

          <Whisper
            trigger="click"
            placement="top"
            open={showAddBlock}
            onClose={() => setShowAddBlock(false)}
            speaker={
              <Popover>
                <Dropdown.Menu>
                  <Dropdown.Item
                    icon={<MdCode />}
                    onClick={handleAddHtmlBlock}
                  >
                    Texto (HTML)
                  </Dropdown.Item>
                  <Dropdown.Item
                    icon={<MdHelp />}
                    onClick={handleAddQuestionBlock}
                  >
                    Pergunta Prática
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Popover>
            }
          >
            <AddBlockButton onClick={() => setShowAddBlock(true)}>
              <MdAdd />
              Adicionar Bloco
            </AddBlockButton>
          </Whisper>
        </Section>
      </MainContent>

      {/* Modal de seleção de questão */}
      <QuestionSelector
        open={questionSelectorOpen}
        onClose={() => setQuestionSelectorOpen(false)}
        onSelect={handleSelectQuestion}
        onCreateNew={() => {
          setQuestionSelectorOpen(false);
          setQuestionEditorOpen(true);
        }}
        title="Selecionar Questão do Banco"
      />

      {/* Modal de criação de questão */}
      <QuestionEditor
        open={questionEditorOpen}
        onClose={() => setQuestionEditorOpen(false)}
        onSave={handleCreateQuestion}
        loading={savingQuestion}
      />

      {/* Modal de confirmação de exclusão */}
      <ConfirmDialog
        open={deleteBlockModal.open}
        onClose={() => setDeleteBlockModal({ open: false, id: null })}
        onConfirm={handleDeleteBlock}
        title="Excluir Bloco"
        message="Tem certeza que deseja excluir este bloco de conteúdo?"
        confirmText="Excluir"
        loading={deletingBlock}
      />
    </PageContainer>
  );
}

EditorModuloAula.propTypes = {
  showEditorModulos: PropTypes.bool.isRequired,
  setShowEditorModulos: PropTypes.func.isRequired,
  idModulo: PropTypes.number.isRequired,
  idTreinamentoModulos: PropTypes.number.isRequired,
  setShowModulos: PropTypes.func.isRequired,
};

export default EditorModuloAula;
